import { c as _c } from "react/compiler-runtime";
import type { Employee } from '@newfront-insurance/account-ui';
import { createContext, useCallback, useMemo, useState, type JSX } from 'react';
import * as React from 'react';
import { useLoggedInUser } from '@/client/hooks/use-logged-in-user';
import { useIsProducer, useCanSelectProducer } from '@/client/hooks/use-permission';
import { useProducersMap } from '@/client/hooks/use-producers-map';
export interface SelectedProducerContextValue {
  setCurrentProducer: (producerUuid: string) => void;
  removeCurrentProducer: () => void;
  currentProducer?: Employee;
  currentProducerUserUuid?: string;
  currentProducerEmployeeUuid?: string;
}
export const SelectedProducerContext = createContext<SelectedProducerContextValue>({
  currentProducer: undefined,
  setCurrentProducer: () => ({}),
  removeCurrentProducer: () => ({})
});
interface Props {
  children: React.ReactNode;
  localStorageKey: string;
}
export function SelectedProducerProvider(t0) {
  const $ = _c(19);
  const {
    children,
    localStorageKey
  } = t0;
  const initialProducerUuid = useInitialProducerUuid(localStorageKey);
  const [currentProducerUserUuid, setCurrentProducerUserUuid] = useState(initialProducerUuid);
  const {
    producersMap
  } = useProducersMap();
  let t1;
  if ($[0] !== currentProducerUserUuid || $[1] !== producersMap) {
    t1 = currentProducerUserUuid ? producersMap.get(currentProducerUserUuid) : undefined;
    $[0] = currentProducerUserUuid;
    $[1] = producersMap;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentProducer = t1;
  let t2;
  if ($[3] !== currentProducerUserUuid || $[4] !== producersMap) {
    t2 = currentProducerUserUuid ? producersMap.get(currentProducerUserUuid)?.uuid : undefined;
    $[3] = currentProducerUserUuid;
    $[4] = producersMap;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const currentProducerEmployeeUuid = t2;
  let t3;
  if ($[6] !== localStorageKey) {
    t3 = uuid => {
      setCurrentProducerUserUuid(uuid);
      localStorage.setItem(localStorageKey, uuid);
    };
    $[6] = localStorageKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSelectProducer = t3;
  let t4;
  if ($[8] !== localStorageKey) {
    t4 = () => {
      setCurrentProducerUserUuid(undefined);
      localStorage.removeItem(localStorageKey);
    };
    $[8] = localStorageKey;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleRemoveProducer = t4;
  let t5;
  let t6;
  if ($[10] !== currentProducer || $[11] !== currentProducerEmployeeUuid || $[12] !== currentProducerUserUuid || $[13] !== handleRemoveProducer || $[14] !== handleSelectProducer) {
    t6 = {
      currentProducer,
      currentProducerUserUuid,
      currentProducerEmployeeUuid,
      setCurrentProducer: handleSelectProducer,
      removeCurrentProducer: handleRemoveProducer
    };
    $[10] = currentProducer;
    $[11] = currentProducerEmployeeUuid;
    $[12] = currentProducerUserUuid;
    $[13] = handleRemoveProducer;
    $[14] = handleSelectProducer;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  t5 = t6;
  const value = t5;
  let t7;
  if ($[16] !== children || $[17] !== value) {
    t7 = <SelectedProducerContext.Provider value={value}>{children}</SelectedProducerContext.Provider>;
    $[16] = children;
    $[17] = value;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function useInitialProducerUuid(localStorageKey) {
  const $ = _c(2);
  const canSelectProducer = useCanSelectProducer();
  const isProducer = useIsProducer();
  const user = useLoggedInUser();
  if (canSelectProducer) {
    let t0;
    if ($[0] !== localStorageKey) {
      t0 = localStorage.getItem(localStorageKey) || undefined;
      $[0] = localStorageKey;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  if (isProducer) {
    return user?.uuid;
  }
}